import React from 'react';
import styles from './Advt.module.css';
import cn from 'classnames';
// import QRcode from '../../assets/images/qrcode.png'
import { iconsSources } from '../../helpers/icons';
import { formatPhoneNumber } from '../../helpers/titreHelper';

const Advt = React.memo(({ className, advtInfo }) => {
  let phoneNumberFormat = formatPhoneNumber(advtInfo?.number, ' ');
  return (
    <div className={cn(className)}>
      <div
        className={cn(styles.wrapper, {
          [styles.wrapper__hidden]:
            !advtInfo.label &&
            !phoneNumberFormat &&
            !advtInfo.socials &&
            !advtInfo.qrCode,
        })}
      >
        {/* {advtInfo.qrCode && (
          <div className={styles.left}>
            <img src={advtInfo.qrCode} alt="qr-code" />
          </div>
        )} */}
        {(advtInfo.label || phoneNumberFormat || advtInfo.socials) && (
          <div className={styles.right}>
            <div className={styles.desc}>
              {advtInfo.socials &&
                advtInfo.socials.map((item) => (
                  <div key={item} className={styles.icon}>
                    <img src={iconsSources[item]} alt={item} />
                  </div>
                ))}
            </div>

            <div className={styles.number}>{phoneNumberFormat}</div>
            <div className={styles.title}>{advtInfo.label}</div>
          </div>
        )}
      </div>
    </div>
  );
});

export default Advt;
